import { ChangeEventHandler } from "react";

import { ColorPaletteProps } from "~/bff/components/ColorPalette";
import { FacetCountsFacetFields } from "~/bff/types/FacetCountsFacetFields";
import { FacetCountsFacetFieldsCategory } from "~/bff/types/FacetCountsFacetFieldsCategory";
import { FacetCountsFacetRanges } from "~/bff/types/FacetCountsFacetRanges";
import { ImageSource } from "~/bff/types/ImageSource";
import { ShoppingTypeFilter } from "~/bff/types/ShoppingTypeFilter";
import { SkuPrice } from "~/bff/types/SkuPrice";
import { Store } from "~/bff/types/Store";
import { Nullable } from "~/types/general.types";
import { ProductRequestType } from "~/types/products-request-handler";

import { ShopFilterProps } from "./components/filter/components/shop-filter/component";

export type AppliedFilters = Record<string, number | boolean> | null;

export interface MultiFilter {
  count?: Nullable<number>;
  name?: Nullable<string>;
}

export type ProductFilter = FacetCountsFacetFieldsCategory | MultiFilter | SkuPrice;

export type HandleFiltersCallback =
  | ChangeEventHandler<HTMLInputElement>
  | ((event: ChangeEventHandler<HTMLInputElement>, codedFilter?: string) => void);

export type Filters = FacetCountsFacetFields & FacetCountsFacetRanges;

export enum FilterTypes {
  swatch = "swatch",
  multi = "multi",
  color = "color",
  price = "price",
  shop = "shop",
}

export interface CombinedColorFilter {
  count?: Nullable<number>;
  colorImage: {
    src: string;
    alt?: string;
    source?: ImageSource;
    title?: string;
  };
  checkMarkColor?: Nullable<string>;
  colorCode?: Nullable<number>;
  colorName?: string;
}

export interface FacetsNameFromCms {
  facet: string;
  displayName: string;
}

export interface ProductsFiltersProps {
  appliedFilters?: Nullable<AppliedFilters>;
  onFiltersClick?: HandleFiltersCallback;
  filtersData: Filters;
  isFiltersOpen: boolean;
  onFiltersClose: () => void;
  onAllFiltersClear?: () => void;
  className?: string;
  drawerClassName?: string;
  filtersCaptionDesktop: string;
  filtersCaptionMobile: string;
  colorPalette: ColorPaletteProps;
  onShopFilterClick: (store: Store) => void;
  isShopFilter: boolean | null;
  currentStore: Nullable<Store> | undefined;
  onUpdateStore: (store: Nullable<Store>) => void;
  productFilterClearAllButtonText?: Nullable<string>;
  shopFilter?: ShoppingTypeFilter;
  setShopFilterSortingParam?: (value: ProductRequestType) => void;
  onShopFilterDropdown?: (value: ProductRequestType) => void;
  setIsShopFilterChipOptionShow?: (prev: boolean) => void;
  shopFilterProps?: ShopFilterProps;
  numberItems: Nullable<number>;
}
